<template>
    <main-content>
        <ul class="nav nav-pills mb-3">
            <li class="nav-item">
                <button :class="['btn shadow-sm nav-link', (current_tab === 'settlement_list' ? 'active' : '')]"
                        type="button"
                        @click="setTab('settlement_list')"
                >
                    {{ $t('label.settlement_list') }}
                </button>
            </li>
<!--            <li class="nav-item" >-->
<!--                <button :class="['btn shadow-sm nav-link', (current_tab === 'settlement_requests' ? 'active' : '')]"-->
<!--                        type="button"-->
<!--                        @click="setTab('settlement_requests')"-->
<!--                >-->
<!--                    {{ $t('label.settlement_requests') }}-->
<!--                </button>-->
<!--            </li>-->
            <li class="nav-item" v-if="$can('read', 'settlement')">
                <button :class="['btn shadow-sm nav-link', (current_tab === 'manage_banking_wage' ? 'active' : '')]"
                        type="button"
                        @click="setTab('manage_banking_wage')"
                >
                    {{ $t('label.manage_banking_wage') }}
                </button>
            </li>
            <li class="nav-item" v-if="$can('manage', 'all')">
                <button :class="['btn shadow-sm nav-link', (current_tab === 'add_admin_phone' ? 'active' : '')]"
                        type="button"
                        @click="setTab('add_admin_phone')"
                >
                    {{ $t('label.setting') }}
                </button>
            </li>
        </ul>
        <div class="tab-content">
            <div v-if="current_tab === 'settlement_list'">
                <manage-access-get-list v-if="$can('read', 'settlement')"></manage-access-get-list>
                <common-access-get-list v-else></common-access-get-list>
            </div>
            <div v-else-if="current_tab === 'settlement_requests'">
                <Queue></Queue>
            </div>
          <div v-else-if="current_tab === 'manage_banking_wage'">
                <changeBankingWage v-if="$can('read', 'settlement')"></changeBankingWage>
            </div>
            <div v-else-if="current_tab === 'add_admin_phone'">
                <admin-phones></admin-phones>
            </div>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import manageAccessGetList from './component/manage-access-get-list'
    import commonAccessGetList from './component/common-access-get-list'
    import changeBankingWage from './component/ChangeBankingWage.vue'
    import Queue from "@/views/settlement/Queue";
    import AdminPhones from "./component/AdminPhones.vue";

    export default {
        components: {
            AdminPhones,
            mainContent,
            manageAccessGetList,
            commonAccessGetList,
            Queue,
          changeBankingWage,
        },
        data() {
            return {
                current_tab: 'settlement_list',
            };
        },
        methods: {
            setTab(tab) {
                this.current_tab = tab;
            },
        }
    }
</script>

<style>
    .badge-warning-danger {
        background-color: #ff7328;
    }
    .badge-success-grass {
        background-color: #1dc989;
    }
</style>